import styled, {css} from 'styled-components';

import {color} from '../../../shared/styles';

export const Container = styled.div<{disabled: boolean}>`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  flex-direction: row-reverse;

  &.reverse {
    flex-direction: row;
    justify-content: end;

    input {
      margin: 0 15px;
    }
  }

  input {
    -webkit-appearance: none;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid ${color.mediumLight};
    box-sizing: border-box;
    cursor: pointer;
    height: 20px;
    margin: 0 15px 0;
    outline: none;
    padding: 9px;
    position: relative;
    width: 20px;

    &:checked {
      position: relative;

      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 14px;
        height: 14px;
        margin: auto;
        background-color: ${({disabled}) =>
          disabled ? color.mediumLight : color.bluePrimary};
        border-radius: 16px;
      }
    }

    ${({disabled}) =>
      disabled &&
      css`
        pointer-events: none;
      `}
  }
`;

export default Container;
